var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 -1.07487e-09L16 -5.73266e-09C16.7956 -6.01773e-09 17.5587 0.318661 18.1213 0.885882C18.6839 1.4531 19 2.22242 19 3.02459L19 12.0984C19 12.9005 18.6839 13.6698 18.1213 14.2371C17.5587 14.8043 16.7956 15.123 16 15.123L3 15.123C2.20435 15.123 1.44129 14.8043 0.87868 14.2371C0.316071 13.6698 -4.58456e-09 12.9005 -4.29949e-09 12.0984L-1.07487e-09 3.02459C-7.89798e-10 2.22242 0.316071 1.4531 0.87868 0.885882C1.44129 0.318661 2.20435 -7.89798e-10 3 -1.07487e-09ZM3 1.0082C2.5 1.0082 2.06 1.17959 1.72 1.48205L9.5 6.55328L17.28 1.48205C16.94 1.17959 16.5 1.0082 16 1.0082L3 1.0082ZM9.5 7.7732L1.13 2.29869C1.05 2.52049 1 2.77254 1 3.02459L1 12.0984C1 12.6331 1.21071 13.146 1.58579 13.5242C1.96086 13.9023 2.46957 14.1148 3 14.1148L16 14.1148C16.5304 14.1148 17.0391 13.9023 17.4142 13.5242C17.7893 13.146 18 12.6331 18 12.0984L18 3.02459C18 2.77254 17.95 2.52049 17.87 2.29869L9.5 7.7732Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.a54f4d681ce0eafa4a693f1160a605e6.svg";
export { ForwardRef as ReactComponent };